import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AppDefaultFooter from 'base-ui/dist/DefaultFooter';
import { intl } from 'components/LocaleProvider';
import { fetchMenu } from 'state/slices/menus';
import messages from './messages';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const { DefaultFooterCertificationTypes, DefaultFooterTypes } = AppDefaultFooter;

const DefaultFooter = () => {
  const dispatch = useDispatch();
  const { items: menus } = useSelector((state) => state.menus);
  const { items: sidebars } = useSelector((state) => state.sidebars);
  const footerType = (publicRuntimeConfig.footer_grid) ? DefaultFooterTypes.FOOTER_GRID : DefaultFooterTypes.FOOTER_DEFAULT;
  const certifications = [];
  const certificationsCode = {};

  const certs = certifications;
  if (publicRuntimeConfig.hon_code) {
    certs.push(DefaultFooterCertificationTypes.HONCODE);
    certificationsCode[DefaultFooterCertificationTypes.HONCODE] = publicRuntimeConfig.hon_code_id ? publicRuntimeConfig.hon_code_id : null;
  }

  if (publicRuntimeConfig.accreditation) {
    certs.push(DefaultFooterCertificationTypes.WIP);
    certificationsCode[DefaultFooterCertificationTypes.WIP] = publicRuntimeConfig.wip_code_id ? publicRuntimeConfig.wip_code_id : null;
  }

  useEffect(() => {
    dispatch(fetchMenu('legal'));
    dispatch(fetchMenu('social_links'));
    dispatch(fetchMenu('external_links'));
    dispatch(fetchMenu('version_links'));
    // if (!sidebars['footer-grid']) {
    //   dispatch(fetchSidebar('footer-grid'));
    // }
  }, []);

  return (
    <AppDefaultFooter
      routerStrategy="next"
      menus={{
        legal: { content: menus.legal || [] },
        social_links: { content: menus.social_links || [] },
        external_links: { content: menus.external_links || [] },
        version_links: { content: menus.version_links || [] },
        footer_grid: { content: sidebars['footer-grid'] || { widgets: [] } },
      }}
      certification={certifications}
      certificationsCode={certificationsCode}
      showCurrencySelect={false}
      platformConfig={{
        name: publicRuntimeConfig.blogname,
        description: publicRuntimeConfig.blogdescription,
        disclaimer: intl.formatMessage(messages.disclaimer),
        textLastUpdated: intl.formatMessage(messages.lastUpdate, {
          lastUpdate: publicRuntimeConfig.LAST_UPDATE
        }),
      }}
      type={footerType}
    />
  );
};

export default DefaultFooter;
